import { ORPCError, isDefinedError } from "@orpc/client";

type LegacyErrorBody = {
  errorCode?: number | string;
  statusCode?: number;
  message?: string;
  error?: {
    message?: string;
    detail?: unknown;
  };
  captcha_required?: boolean;
  captcha_key?: string;
  master_image_base64?: string;
  thumb_image_base64?: string;
  [key: string]: unknown;
};

function isRecord(value: unknown): value is Record<string, unknown> {
  return typeof value === "object" && value !== null;
}

export function isORPCError(error: unknown): error is ORPCError {
  return error instanceof ORPCError || isDefinedError(error);
}

export function getLegacyErrorBody(
  error: unknown
): LegacyErrorBody | undefined {
  if (!isORPCError(error) || !isRecord(error.data)) {
    return undefined;
  }

  const legacyBody = error.data.legacyBody;
  return isRecord(legacyBody) ? (legacyBody as LegacyErrorBody) : undefined;
}

export function getORPCErrorCode(error: unknown): number | undefined {
  const legacyCode = getLegacyErrorBody(error)?.errorCode;
  if (typeof legacyCode === "number") {
    return legacyCode;
  }

  if (typeof legacyCode === "string") {
    const parsed = Number(legacyCode);
    return Number.isNaN(parsed) ? undefined : parsed;
  }

  return undefined;
}

export function getORPCStatus(error: unknown): number | undefined {
  return (
    getLegacyErrorBody(error)?.statusCode ??
    (isORPCError(error) ? error.status : undefined)
  );
}

export function getORPCErrorMessage(error: unknown): string | undefined {
  const legacyBody = getLegacyErrorBody(error);
  if (legacyBody?.error?.message) {
    return legacyBody.error.message;
  }

  if (legacyBody?.message) {
    return legacyBody.message;
  }

  return error instanceof Error ? error.message : undefined;
}
